import React, { useState } from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import MoreDetailsDriver from './MoreDetailsDriver';
// import { filterStatusData } from 'pages/vendor/VendorBreadCrumbData';

const SubVendorTablist = (props) => {
  const {
    vehicledata,
    driverData,
    handleTabChange,
    subVendorMoreDetails,
    subVendorLocation,
    onClickSubvendorTable,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
    onFilterChange,
    onRestFilter,
    onSearch,
    defaultStatus,
    chooseYourServiceData,
    loaderDriver,
    loaderVehicle,
    loaderSubVendorMoreData,
    onClickMoreIcon,
    viewMoreIconDriver,
    viewMoreIconVehicle,
    search,
    filterdata
  } = props;
  
  const [value, setValue] = useState('drivers');

  const handleTab = (event, newValue) => {
    handleTabChange(newValue);
    setValue(newValue);
  };

  return (
    <Box className="mt30">
      <Grid container>
        <Grid item className="tabContainer" xs={12}>
          <Box className="contentBoxStyle">
            <TabContext value={value}>
              <Grid
                container
                className="tabBoxStyle"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item xs={6} sm={6}>
                  <TabList
                    onChange={handleTab}
                    aria-label="lab API tabs example"
                    TabIndicatorProps={{
                      style: { backgroundColor: 'white' },
                    }}
                  >
                    <Tab label="Driver" value="drivers" className="tabStyle" />

                    <Tab
                      label="Vehicle"
                      value="vehicleDetails"
                      className="tabStyle"
                    />

                    <Tab
                      label="More Details"
                      value="moreDetails"
                      className="tabStyle"
                    />
                  </TabList>
                </Grid>
                {value !== 'moreDetails' && (
                  <Grid
                    item
                    container
                    xs={6}
                    sm={6}
                    spacing={1}
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Grid item xs={7}>
                      <SearchBar onSearchQuery={onSearch} search={search} />
                    </Grid>
                    <Grid item>
                      <CommonFilter
                        defaultStatus={defaultStatus}
                        filterdata={filterdata}
                        onFilterChange={onFilterChange}
                        onRestFilter={onRestFilter}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <TabPanel value="drivers" className="mt30">
                {loaderDriver ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={driverData}
                    tableOnClickRow={onClickSubvendorTable}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onClickMoreIcon={onClickMoreIcon}
                    isClickable={true}
                    viewMoreIcon = {!viewMoreIconDriver}
                    tabName={'driver'}
                  />
                )}
              </TabPanel>
              <TabPanel value="vehicleDetails" className="mt30">
                {loaderVehicle ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={vehicledata}
                    tableOnClickRow={onClickSubvendorTable}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    tabName={'vehicle'}
                    isClickable={true}
                    onClickMoreIcon={onClickMoreIcon}
                    viewMoreIcon={!viewMoreIconVehicle}
                  />
                )}
              </TabPanel>
              <TabPanel value="moreDetails" className="mt30">
                {loaderSubVendorMoreData ? (
                  <Loader />
                ) : (
                  <MoreDetailsDriver
                    subVendorMoreDetails={subVendorMoreDetails}
                    subVendorLocation={subVendorLocation}
                    chooseYourServiceData={chooseYourServiceData}
                  />
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubVendorTablist;
